import React, { useState, useEffect, useRef } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
import Select from "react-select";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Style.css";
import { TailSpin } from "react-loader-spinner";
import Add_VenueownerPackages from "../../Components/Venue_owner_comp/add_packages.js";
import Update_VenueownerPackages from "../../Components/Venue_owner_comp/update_packages.js";
import Delete_VenueownerPackages from "../../Components/Venue_owner_comp/delete_packages.js";
import "../../Api/apiUrls.js";
import {API_URL, getPackageForVenue} from "../../Api/apiUrls";

function VenueownerPackages() {
  const [
    modalAdd_VenueownerPackagesIsOpen,
    setAdd_VenueownerPackagesModalIsOpen,
  ] = useState("");
  const [
    modalUpdate_VenueownerPackagesIsOpen,
    setUpdate_VenueownerPackagesModalIsOpen,
  ] = useState(false);
  const [packages, setPackages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [
    modalDelete_VenueownerPackagesIsOpen,
    setDelete_VenueownerPackagesIsOpen,
  ] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const status = [
    { value: "All", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  const openAdd_VenueownerPackages = () => {
    closeAdd_VenueownerPackages();
    setAdd_VenueownerPackagesModalIsOpen(true);
  };

  const closeAdd_VenueownerPackages = () => {
    setAdd_VenueownerPackagesModalIsOpen(false);
  };
  const openUpdate_VenueownerPackages = () => {
    closeUpdate_VenueownerPackages();
    setUpdate_VenueownerPackagesModalIsOpen(true);
  };

  const closeUpdate_VenueownerPackages = () => {
    setUpdate_VenueownerPackagesModalIsOpen(false);
  };
  const openDelete_VenueownerPackages = (userId) => {
    setSelectedUserId(userId);
    closeDelete_VenueownerPackages();
    setDelete_VenueownerPackagesIsOpen(true);
  };

  const closeDelete_VenueownerPackages = () => {
    setDelete_VenueownerPackagesIsOpen(null);
  };

  const statusOptions = [
    { value: "All", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  const [selectedStatus, setSelectedStatus] = useState(statusOptions[0]);
  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
  };
  useEffect(() => {
    fetch(`${getPackageForVenue}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const packages = data.data.Package;
        console.log(packages);
        setPackages(packages);
      })
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => {
        setIsLoading(false);
        console.log("Package value:", packages);
      });
  }, []);
  const filteredPackages = packages.filter((packages) => {
    if (selectedStatus.value === "All") {
      return true;
    }
    return packages.status === selectedStatus.value;
  });

  return (
    <div>
      <Header></Header>
      {modalAdd_VenueownerPackagesIsOpen && (
        <Add_VenueownerPackages onClose={closeAdd_VenueownerPackages} />
      )}
      {modalUpdate_VenueownerPackagesIsOpen && (
        <Update_VenueownerPackages onClose={closeUpdate_VenueownerPackages} />
      )}
      {modalDelete_VenueownerPackagesIsOpen && (
        <Delete_VenueownerPackages
          userId={selectedUserId}
          onClose={closeDelete_VenueownerPackages}
        />
      )}
      <main id="main" class="main">
        <div class="pagetitle">
          <h1>Packages</h1>
          {/* <nav>
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="/categories">Home</a>
              </li>
              <li class="breadcrumb-item active">Packages</li>
            </ol>
          </nav> */}
        </div>
        <section class="section">
          <div class="card p-2">
            <div class="parent col-md-12 row mt-2">
              <div class="col-md-6">
                <div class="child">
                  <input
                    id="myInput"
                    type="text"
                    style={{
                      borderRadius: "5px",
                      height: "35px",
                      padding: "10px",
                      border: "1px solid lightgrey ",
                    }}
                    placeholder="Search..."
                  />
                </div>
                <div class="child ml-2">
                  <Select
                    options={statusOptions}
                    placeholder="Select Status"
                    onChange={handleStatusChange}
                    value={selectedStatus}
                  ></Select>
                </div>
              </div>
              <div className="col-md-6" style={{ textAlign: "right" }}>
                <div className="child">
                  {/* <button
                    id="btnNewUser"
                    type="button"
                    data-toggle="modal"
                    data-target="#modalAdd"
                    className="btn-round"
                    onClick={openAdd_VenueownerPackages}
                  >
                    <i className="bi bi-person-add"></i> Add Packages
                  </button> */}
                </div>
              </div>
            </div>

            <div
              style={{ marginTop: "50px", display: "flex", marginLeft: "52%" }}
            >
              {/* <TailSpin color="black" width={50} /> */}
            </div>
            <div class="table-responsive">
              <table class="table table-striped ">
                {isLoading === true ? (
                  <div style={{ marginTop: "50px", marginLeft: "50%" }}>
                    <TailSpin color="black" width={50} />
                  </div>
                ) : packages.length > 0 ? (
                  <table class="table table-striped  ">
                    <thead>
                      <tr>
                        <th scope="col">Sr.no</th>
                        <th scope="col">Name </th>
                        <th scope="col">Status</th>
                        <th scope="col">Price</th>
                        <th scope="col">Duration</th>
                        <th scope="col">Type</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody id="tableBody">
                      {/* {packages.map((packages, index) => ( */}
                      {filteredPackages.map((packages, index) => (
                        <tr key={packages.id}>
                          <th scope="row">{index + 1}</th>

                          <td>
                            {packages.name || "No Name"}
                            <br />
                          </td>

                          <td>
                            {packages.status || "No Name"}
                            <br />
                          </td>
                          <td>
                            {packages.price || "No Name"}
                            <br />
                          </td>
                          <td>
                            {packages.duration || "No Name"}
                            <br />
                          </td>
                          <td>
                            {packages.type || "No Name"}
                            <br />
                          </td>
                          <td>
                            <button
                              id="btnNewUser"
                              type="button"
                              data-toggle="modal"
                              data-target="#modalAdd"
                              class=" btn-round"
                              style={{ marginRight: "10px" }}
                            >
                              <i></i> Buy
                            </button>

                            <button
                              id="btnNewUser"
                              type="button"
                              data-toggle="modal"
                              data-target="#modalAdd"
                              class=" btn-round"
                            >
                              <i></i> Cancel
                            </button>
                          </td>

                          {/* <td>
                            <div className="social-links mt-2">
                              <a
                                onClick={() =>
                                  openUpdate_banners(
                                    banner.id,
                                    banner.title,
                                    banner.photo,
                                    banner.status
                                  )
                                }
                              >
                                <i className="fas fa-pencil-alt"></i>
                              </a>
                              &nbsp;
                              <a onClick={() => openDelete_banners(banner.id)}>
                                <i className="fas fa-trash-alt"></i>
                              </a>
                            </div>
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <h3 style={{ textAlign: "center" }}> No data available </h3>
                )}
              </table>
            </div>
          </div>
          <div>
            {" "}
            <p
              style={{
                backgroundColor: "#595857",
                color: "white",
                padding: "10px",
              }}
            >
              {packages.length} Total
            </p>
          </div>
        </section>
      </main>
      <Footer></Footer>
    </div>
  );
}

export default VenueownerPackages;
